/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * @module enervee_utils.product_sections
 */
function productDetailDirective() {
    return {
        restrict: 'E',
        scope: {
            product: '<?',
            productImageSizes: '=',
        },
        controllerAs: 'vm',
        bindToController: true,
        controller: productDetailController,
        template: require('./productDetailView.html')
    };
}

productDetailController.$inject = [
    'ProductService',
    'UtilService',
    'CmsContentService',
    'AdService',
];
function productDetailController (
    ProductService,
    UtilService,
    CmsContentService,
    AdService
) {
    
    this.$onInit = function () {

        let vm = this;
        vm.closeMobileSection = closeMobileSection;

        CmsContentService.retrieveCMSValue(vm, 'imageGalleryLoaderText', 'details_page:image_gallery_loader_text');
        CmsContentService.retrieveCMSValue(vm, 'productFeaturesLoaderText', 'details_page:product_features_loader_text');

        setupAds();
        setupImageGallery();
        setupSponsoredContent();
        setupProductFeatures();

        /**
         * Advertisement settings
         */
        function setupAds() {
            // AppNexus ads
            vm.adsEnabled = AdService.adsEnabled;

            // Smart AdServer ads
            vm.adSettings = ProductService.setAdSettings(
                ['side1', 'side2', 'body', 'mobile', 'mobile_features',
                    'mobile_efficiency', 'mobile_price', 'mobile_rating']
            );
        }

        /**
         * Sets the image gallery section up
         */
        function setupImageGallery() {
            vm.loadingProductImages = true;

            ProductService.getProductImagesForCloudinary(vm.product.id).then(function (productImages) {
                vm.productImages = productImages;
                vm.loadingProductImages = false;
            });
        }

        /**
         * Handles sponsored content's view model implementations
         */
        function setupSponsoredContent() {
            const isSponsoredContentEnabled = UtilService.isFeatureEnabled("sponsored_content");

            vm.showSponsoredContent = false;
            if (isSponsoredContentEnabled) {
                ProductService.fetchSponsoredContent(vm.product.id).then(function () {
                    vm.sponsoredContent = ProductService.getSponsoredContent();
                    if (vm.sponsoredContent) {
                        vm.showSponsoredContent = true;
                    }
                });
            }
        }

        /**
         * Sets the product features section up
         */
        function setupProductFeatures() {
            vm.loadingProductFeatures = true;
            ProductService.getProductFeatures(vm.product.id).then(function (productFeatures) {
                vm.productFeatures = productFeatures;
                vm.loadingProductFeatures = false;
            });

            vm.productFeaturesDescription = vm.product.features_description;
        }

    };

    function closeMobileSection () {
        // Close all open sections (prevent stacking)
        closeAllMobileSections();

        $('#page-fold').addClass('open');

        $('#call-to-action').addClass('open');
    }

    /**
     * Mobile section handling
     */
    function closeAllMobileSections () {
        // Close all open sections (prevent stacking)
        $('.product-section').removeClass('open');
    }

}

module.exports = productDetailDirective;
